import React from 'react'

const GroupsContext = React.createContext({
  groups: null
})

export default GroupsContext
